import React, { useState } from 'react';
import { CompositeView, Form, FormDatePicker, FormInput, FormSelect, GridView, MasterDetailForm, SimpleView, usePromise, Widget } from '@digital/ui';
import { updateUsuario, getUsuarioInfo, Usuario } from '../../api/usuario';
import { getLoggedId } from '../../helpers';
import { getAllPerfilMrnOptions } from '@app/api/PerfilAcesso';

const MeusDados = () => {
    const userId = getLoggedId();
    const [userInfo] = usePromise(
        () => (userId ? getUsuarioInfo(userId) : Promise.resolve(undefined)),
        [userId],
        {} as Usuario,
    );
    const [PerfilOptions, setPerfilOptions] = useState(getAllPerfilMrnOptions);
    return (
        <CompositeView>
            <SimpleView>
                <GridView noform>

                    <MasterDetailForm
                        initialValues={userInfo}>
                        <Widget
                            title="Dados de Usuário"
                            actions={[]}>
                            <FormInput label="Username" name="username" disabled span={6} />
                            <FormDatePicker format="DD/MM/YYYY" label="Data do último Acesso" name="dataHoraUltimaAcesso" disabled span={6} />
                            <FormInput disabled={true} label="Nome" name="nome" span={6} />
                            <FormInput disabled={true} label="E-mail" name="email" span={6} />
                            <FormInput disabled={true} label="Cargo" name="cargo" span={6} />
                            <FormInput disabled={true} label="Telefone 1" name="telefone1" span={3} />
                            <FormInput disabled={true} label="Telefone 2" name="telefone2" span={3} />
                            <fieldset>
                                <legend>Tipos de Usuários</legend>
                                <FormInput label="Identificador ERP" name="identificadorErp" disabled span={6} />
                                <FormInput label="Tipo de Usuário" name="tipoUsuario" disabled span={6} />
                            </fieldset>
                            <fieldset>
                                <legend>Perfil</legend>
                                <FormSelect disabled={true} mode="multiple" label="Perfis" name="perfis" options={PerfilOptions} span={12} />
                            </fieldset>

                            <fieldset>
                                <legend> Organograma </legend>

                                <FormInput
                                    label="Diretoria"
                                    name="diretoriaNome"
                                    span={4}
                                    disabled={true}
                                />
                                <FormInput
                                    label="Área"
                                    name="areaNome"
                                    span={4}
                                    disabled={true}
                                />
                                <FormInput
                                    label="Departamento"
                                    name="departamentoNome"
                                    span={4}
                                    disabled={true}
                                />
                            </fieldset>
                        </Widget>
                    </MasterDetailForm>
                </GridView>
            </SimpleView>
        </CompositeView>
    );
};

export default MeusDados;
